import { theme } from '@notino/react-styleguide';
export default theme;
